$(document).ready(function () {



    let single_building_thumbs = new Swiper(".single_building_slider_items", {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 4,
        watchSlidesProgress: true,

        on: {
            init(swiper) {
                updateThumbAccessibility(swiper);
            },
            slideChange(swiper) {
                updateThumbAccessibility(swiper);
            },
            progress(swiper) {
                updateThumbAccessibility(swiper);
            },
        },
    });

    const single_building = new Swiper('.single_building_slider.swiper', {
        loop: true,
        slidesPerView: 1,
        thumbs: {
            swiper: single_building_thumbs,
        },
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.single_building_slider_next',
            prevEl: '.single_building_slider_prev',
        },

        pagination: {
            el: '.single_building_slider_pagination',
            clickable: true
        },
        on: {
            init() {
                updateThumbLabels(single_building_thumbs);
            },
            slideChangeTransitionEnd() {
                updateThumbLabels(single_building_thumbs);
            },
            slideChange() {
                updateThumbAccessibility(single_building_thumbs);
            },
        }

    });

    $('body').on('click', '.single_building_slider_items button', function (){
        single_building.slideTo($(this).parent().data('swiper-slide-index'));
    });


    const unit_sliders = {};
    unit_sliders['single_building'] = single_building;

    document.querySelectorAll('.unit_type_item_carousel').forEach(swiperEl => {
        const id = swiperEl.dataset.id;
        const swiperInstance = new Swiper(swiperEl, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 8,
            a11y: {
                enabled: true,
                scrollOnFocus: false,
            },

            navigation: {
                nextEl: '.unit_type_item_carousel_next',
                prevEl: '.unit_type_item_carousel_prev',
            },
            pagination: {
                el: '.unit_type_item_pagination',
                type: 'fraction',
            },
            on: {
                init(swiper) {
                    updateAriaHidden(swiper);
                    updateTabindex(swiper);
                },
                slideChange(swiper) {
                    updateAriaHidden(swiper);
                    updateTabindex(swiper);
                },
            }
        });

        unit_sliders[id] = swiperInstance;
    });

    document.addEventListener('click', function (e) {
        const link = e.target.closest('[data-slide][data-target]');
        if (!link) return;

        e.preventDefault();

        const parent = link.closest('.unit_type_item_carousel_links');
        if (parent) {
            parent.querySelectorAll('a').forEach(el => el.classList.remove('active'));
        }
        link.classList.add('active');

        const target = link.getAttribute('data-target');
        const index = parseInt(link.getAttribute('data-slide'), 10) || 0;

        const unit_slider = unit_sliders[target];
        if (unit_slider) {
            unit_slider.slideTo(index);
        } else {
            // Optional: helpful log if mapping missing
            console.warn('No swiper found for target:', target, unit_sliders);
        }
    });


    $('body').on('click', '.single_building_info__content-description--title, .unit_type_map__title, .unit_type_item__heading', function (e) {
        e.preventDefault();

        $(this).parent().toggleClass('open');
        $(this).attr('aria-expanded', $(this).parent().hasClass('open') ? 'true' : 'false');

        $(this).parent().siblings().slideToggle(150).attr('aria-hidden', $(this).parent().hasClass('open') ? 'false' : 'true');

        // $(this).children('.unit_type_item__heading-price').slideToggle(150);

    });

    $('body').on('click', '.unit_type_tab', function (e) {
        e.preventDefault();

        $(this).addClass('active').attr('aria-selected', 'true').siblings().removeClass('active').attr('aria-selected', 'false');


        const index = $(this).index();

        $('.unit_type_item__content').removeClass('active').attr('aria-selected', 'false');
        $('.unit_type_item__content').eq(index).addClass('active').attr('aria-selected', 'true');

        $('.unit_type_item__content-table').removeClass('active');
        $('.unit_type_item__content-table').eq(index).addClass('active');

        setTimeout(() => {
            $('.unit_type_item__content.active .unit_type_item_carousel').each(function () {
                const id = this.dataset.id;
                const swiper = unit_sliders[id];
                if (swiper) {
                    swiper.update();
                    updateAriaHidden(swiper);
                    updateTabindex(swiper);
                }
            });
        }, 0);

    });

    /*document.addEventListener('DOMContentLoaded', function () {
        const tablists = document.querySelectorAll('.unit_types__tabs[role="tablist"]');

        tablists.forEach(function (tablist) {
            const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));

            tabs.forEach(function (tab, index) {
                tab.addEventListener('keydown', function (e) {
                    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') {
                        return;
                    }
                    e.preventDefault();

                    let newIndex = index;

                    if (e.key === 'ArrowRight') {
                        newIndex = (index + 1) % tabs.length;
                    } else if (e.key === 'ArrowLeft') {
                        newIndex = (index - 1 + tabs.length) % tabs.length;
                    }

                    const newTab = tabs[newIndex];

                    tabs.forEach(function (t) {
                        t.setAttribute('tabindex', '-1');
                        t.setAttribute('aria-selected', 'false');
                        t.classList.remove('active');

                        const panelId = t.getAttribute('aria-controls');
                        if (panelId) {
                            const panel = document.getElementById(panelId);
                            if (panel) {
                                panel.hidden = true;
                            }
                        }
                    });

                    newTab.setAttribute('tabindex', '0');
                    newTab.setAttribute('aria-selected', 'true');
                    newTab.classList.add('active');
                    newTab.focus();

                    const newPanelId = newTab.getAttribute('aria-controls');
                    if (newPanelId) {
                        const newPanel = document.getElementById(newPanelId);
                        if (newPanel) {
                            newPanel.hidden = false;
                        }
                    }
                });
            });
        });
    });*/

});


document.addEventListener("DOMContentLoaded", function () {
    const infoContainer = document.querySelector('.unit_type_info');
    const tableMap = new Map();

    document.querySelectorAll('.unit_type_item').forEach((item, index) => {
        const table = item.querySelector('.unit_type_item__content-table');
        if (table) {
            if (tableMap.size === 0) {
                table.classList.add('active');
            }
            tableMap.set(table, {
                originalParent: table.parentElement,
                placeholder: document.createComment(`table-placeholder-${index}`)
            });
        }
    });

    function moveTables() {
        const isDesktop = window.innerWidth >= 1024;

        tableMap.forEach(({originalParent, placeholder}, table) => {
            if (isDesktop) {
                if (!placeholder.isConnected) {
                    originalParent.insertBefore(placeholder, table);
                }
                if (!infoContainer.contains(table)) {
                    infoContainer.appendChild(table);
                }
            } else {
                if (placeholder.isConnected) {
                    placeholder.parentElement.insertBefore(table, placeholder);
                    placeholder.remove();
                }
            }
        });
    }

    moveTables();
    window.addEventListener('resize', moveTables);


    if($('[data-fancybox]').length > 0) {
        Fancybox.bind("[data-fancybox]", {
            Carousel: {
                Toolbar: {
                    display: {
                        left: ["counter"],
                        middle: [],
                        right: ["close"],
                    },
                },
            },
        });
    }

});

function watchButton(callbackDisappear, callbackAppear) {
    let button = document.querySelector('.availability_table__button');

    let intersectionObserver;
    function observeVisibility(el) {
        if (intersectionObserver) intersectionObserver.disconnect();
        intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callbackAppear?.(el);
                } else {
                    callbackDisappear?.(el);
                }
            });
        });
        intersectionObserver.observe(el);
    }

    if (button) observeVisibility(button);

    const mutationObserver = new MutationObserver(() => {
        const el = document.querySelector('.availability_table__button');

        if (el && el !== button) {
            button = el;
            observeVisibility(el);
            callbackAppear?.(el);
        }

        if (!el && button) {
            callbackDisappear?.(button);
            button = null;
            if (intersectionObserver) intersectionObserver.disconnect();
        }
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
}

watchButton(
    () => {
        $('.wrapper_float_button').show();
    },
    () => {
        $('.wrapper_float_button').hide();
    }
);